import React, {Component} from "react";
import {withRouter, NavLink} from "react-router-dom";
import {connect} from "react-redux";
import {Form, Input, Button, Select, message, Spin, Checkbox} from "antd";
import CloudFlyerAPI from "../../../api/CloudFlyerAPI";
import arrowLeft from "../../../assets/img/icon/arrow-left-icon.svg";
import wasabiDarkLogo from "../../../assets/logo/amove-dark-logo.svg";

import "./addNewFeature.scss";

class AddNewFeature extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            formValid: false,
            accountList: [],
            selectedAccount: null,
            selectedUserType: null,
        };
    }

    componentDidMount() {
    }

    handleSubmit = (e) => {
        e.preventDefault();
        console.log("submit account");
        this.setState({loading: true});
        const {name, description, price, priceID, duration, featureType} = this.props.form.getFieldsValue();

        CloudFlyerAPI.product_features
            .addNewFeature({
                "name": name,
                "description": description,
                "price": parseInt(price),
                "priceId": priceID,
                "duration": parseInt(duration),
                "featureType": parseInt(featureType)
            })
            .then(() => {
                message.success("Feature Added Successfully!");
                this.setState({loading: false, formValid: false});
                this.props.form.resetFields(); // Reset form after success
            })
            .catch((err) => {
                message.error("Something went wrong!");
                this.setState({loading: false});
            });


    };
    checkIfFormIsFilled = () => {
        setTimeout(()=>{

            const values = this.props.form.getFieldsValue();
            const requiredFields = ["name", "price", "priceID", "duration", "featureType"];

            const allFieldsFilled = requiredFields.every(field => values[field] && values[field] !== "");
            this.setState({formValid: allFieldsFilled});
        },500)
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {Option} = Select;
        const {loading, formValid} = this.state;
        return (
            <div className="add-new-user-container less-margin">
                <div className="back-wrapper">
                    <NavLink to="/productFeatures"><img src={arrowLeft} alt="icon"/> Back</NavLink>
                </div>
                <div className="content-box">
                    <div className="wasabiLogo">
                        <img alt="wasabi Logo" src={wasabiDarkLogo}/>
                    </div>

                    <div className="add-user-form">
                        <Form
                            layout="horizontal"
                            onSubmit={this.handleSubmit.bind(this)}
                            className="user-form"
                        >
                            <Form.Item>
                                {getFieldDecorator("name")(
                                    <Input placeholder="Name" className="user-input" onChange={this.checkIfFormIsFilled}/>
                                )}
                            </Form.Item>
                            <Form.Item>
                                {getFieldDecorator("description")(
                                    <Input placeholder="Description" className="user-input" onChange={this.checkIfFormIsFilled}/>
                                )}
                            </Form.Item>
                            <Form.Item>
                                {getFieldDecorator("price")(
                                    <Input placeholder="Price" className="user-input" type="number" onChange={this.checkIfFormIsFilled}/>
                                )}
                            </Form.Item>
                            <Form.Item>
                                {getFieldDecorator("priceID")(
                                    <Input placeholder="Price ID" className="user-input" onChange={this.checkIfFormIsFilled}/>
                                )}
                            </Form.Item>
                            <Form.Item>
                                {getFieldDecorator("duration")(
                                    <Select placeholder="Duration" onChange={()=>{
                                        console.log("Duration changed")
                                        this.checkIfFormIsFilled()
                                    }}>
                                        <Option value="1">Monthly</Option>
                                        <Option value="2">Annual</Option>
                                    </Select>
                                )}
                            </Form.Item>
                            <Form.Item>
                                {getFieldDecorator("featureType")(
                                    <Select placeholder="Feature Type" onChange={()=>{
                                        console.log(featureType, "Duration changed")
                                        this.checkIfFormIsFilled()
                                    }}>
                                        <Option value="4">AdminUser</Option>
                                        <Option value="8">CreativeUser</Option>
                                        <Option value="16">StandardUser</Option>
                                        <Option value="32">Connection</Option>
                                        <Option value="64">Project</Option>
                                        <Option value="128">Team</Option>
                                        <Option value="256">Drive</Option>
                                        <Option value="512">Sync</Option>
                                        <Option value="1024">SSO</Option>
                                        <Option value="2048">Logs</Option>
                                        <Option value="4096">FreeUser</Option>
                                        <Option value="8192">FreeConnection</Option>
                                        <Option value="16384">Fastr</Option>
                                        <Option value="32768">PremiumStorage</Option>
                                        <Option value="65536">GlobalStorage</Option>
                                        <Option value="131072">ScaleStorage</Option>
                                        <Option value="262144">ArchiveStorage</Option>
                                    </Select>
                                )}
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    className="user-btn"
                                    type="primary"
                                    size="large"
                                    // loading={this.state.loading}
                                    loading={loading}
                                    htmlType="submit"
                                    disabled={!formValid}
                                    block
                                >
                                    Add New Feature
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(connect()(Form.create()(AddNewFeature)));
